import React from 'react';
import { motion } from 'framer-motion';
import { Avatar } from '../common/Avatar';
import { StateBar } from '../floor/StateBar';
import { answerRateTone, formatDuration, formatPercent } from '../../utils/format';
import type { FloorRow } from '../../utils/floor';
import type { AgentRow } from '../../types/voip';
interface UserMiniCardProps {
  row: AgentRow;
  floor?: FloorRow;
  index: number;
  highlighted: boolean;
  onSelect: (id: string) => void;
}
const ease = [0.23, 1, 0.32, 1] as const;
export function UserMiniCard({
  row,
  floor,
  index,
  highlighted,
  onSelect
}: UserMiniCardProps) {
  const {
    agent,
    stats
  } = row;
  return <motion.li layout="position" initial={{
    opacity: 0,
    y: 6
  }} animate={{
    opacity: 1,
    y: 0
  }} exit={{
    opacity: 0,
    transition: {
      duration: 0.12
    }
  }} transition={{
    duration: 0.22,
    ease,
    delay: Math.min(index * 0.03, 0.2),
    layout: {
      duration: 0.25,
      ease
    }
  }} data-id="element-719" data-mp="3k9ku829nj8u6">
      <motion.button type="button" onClick={() => onSelect(agent.id)} whileHover={{
      y: -2
    }} transition={{
      duration: 0.15,
      ease
    }} aria-label={`${agent.name}, ext. ${agent.extension}. View details`} className={`flex w-full items-start gap-3 rounded-xl border px-3 py-2.5 text-left transition-[border-color,box-shadow,background-color] duration-150 ease-out hover:border-bright/40 hover:shadow-card focus:outline-none focus-visible:ring-2 focus-visible:ring-bright ${highlighted ? 'border-bright/40 bg-bright/5' : 'border-line bg-surface'}`} data-id="element-720" data-mp="2dvd32s00z633">
        <Avatar name={agent.name} size="sm" data-id="element-721" data-mp="2z9nd6vyfc8ch" />
        <span className="min-w-0 flex-1" data-id="element-722" data-mp="3e0vzow715dle">
          <span className="block truncate text-sm font-semibold text-ink" data-id="element-723" data-mp="3dzupetxu8v4q">{agent.name}</span>
          <span className="mt-0.5 flex items-baseline gap-2" data-id="element-724" data-mp="392b8fm9ra493">
            <span className="text-[13px] font-bold text-ink" data-id="element-725" data-mp="3n0j3fon8evhm">{formatDuration(stats.talkSeconds)}</span>
            <span className={`text-xs font-medium ${answerRateTone(stats.answerRate)}`} data-id="element-726" data-mp="3j0qp0vb5pv4c">{formatPercent(stats.answerRate)}</span>
          </span>
          {floor && <span className="mt-1.5 flex items-center gap-2" data-id="element-727" data-mp="3v206q9jynsmw">
              <StateBar day={floor.day} size="xs" data-id="element-728" data-mp="3v29wpx509zsl" />
              <span className="shrink-0 text-[11px] font-medium text-muted" data-id="element-729" data-mp="3v5pp28v2dk6">{Math.round(floor.focus * 100)}% focus</span>
            </span>}
        </span>
      </motion.button>
    </motion.li>;
}